import { Box, Stack, Tab, Tabs, Typography, useTheme } from '@mui/material';

interface IProps {
	tabs: any;
	currentTab: number;
	handleChange: any;
}

export const TabsMenu = ({ tabs, currentTab, handleChange }: IProps) => {
	const theme = useTheme();

	return (
		<Stack sx={{ position: 'relative' }}>
			<Tabs
				value={currentTab || 0}
				onChange={handleChange}
				sx={{
					'& .MuiTabs-indicator': {
						display: tabs.length === 1 ? 'none' : 'inherit',
						background: theme.palette.root.orange_3,
						zIndex: 1,
					},
				}}
			>
				{tabs.length &&
					tabs?.map((tab: any, index: number) => {
						return (
							<Tab
								key={index}
								label={
									<Typography
										variant="subtitle"
										sx={{
											color:
												index === currentTab
													? theme.palette.root.orange_3
													: theme.palette.root.formTitle,
										}}
									>
										{tab.displayTitle}
									</Typography>
								}
							/>
						);
					})}
			</Tabs>
			<Box
				sx={{
					borderBottom: 2,
					borderColor: theme.palette.root.inputFocusGreen,
					opacity: 0.48,
					position: 'absolute',
					bottom: 0,
					width: '100%',
				}}
			></Box>
		</Stack>
	);
};
